import { render, staticRenderFns } from "./item_footer.vue?vue&type=template&id=78b727e4&scoped=true&"
import script from "./item_footer.vue?vue&type=script&lang=js&"
export * from "./item_footer.vue?vue&type=script&lang=js&"
import style0 from "./item_footer.vue?vue&type=style&index=0&id=78b727e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b727e4",
  null
  
)

export default component.exports